/*eslint-disable no-useless-escape*/
import { Actions } from '../components/Actions';
import * as CONSTS from './Consts';

/**
 * api call
 * @param {api url} url 
 * @param {get or post} method 
 * @param {파라메터} params 
 */
export function callApi(url, method, params) {
  Actions.loadingState(true);

  var _body = null;
  if(method === 'get') {
    if(params != null) {
      var queryString = Object.entries(params).map(([key, val]) => `${key}=${val}`).join('&');
      url += '?' + queryString;
    }
  } else if(method === 'post') {
    _body = {
      method: method,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(params)
    }
  }

  return fetch(CONSTS.API_URL + url, _body)
  .then(response => response.json())
  .then(json => {
    Actions.loadingState(false);
    if(json.resultCode === 'fail') {
      var _msg = json.resultMessage ? json.resultMessage : '문제가 발생하였습니다. 다시 시도해보시고,<br/>문제가 지속된다면 관리자에게 문의해주세요.';
      Actions.alertOpen({msg: _msg}, [{type: 'ok', label: '확인'}]);
    }
    return json;
  })
  .catch(err => {
    Actions.loadingState(false);
    Actions.alertOpen({msg: '문제가 발생하였습니다. 다시 시도해보시고,<br/>문제가 지속된다면 관리자에게 문의해주세요.'}, [{type: 'ok', label: '확인'}]);
  })
}

/**
 * 엘리먼트 중앙정렬
 * @param {앨리먼트} ele 
 * @param {가로중앙정렬이 안맞는 경우 true} both 
 */
export function getCenterPosStyle(ele, both) {
  var layerMarginLeft = 0;
  var layerMarginTop = 0;

  if(both) {
    var clientWidth = ele.clientWidth;
    var documentWidth = document.documentElement.offsetWidth;
  
    if (clientWidth < documentWidth ) {
      layerMarginLeft = clientWidth / 2;
    }
  }

  var clientHeight = ele.clientHeight;
  layerMarginTop = (clientHeight / 2);

  return {
    marginTop: '-' + layerMarginTop + 'px',
    marginLeft: '-' + layerMarginLeft + 'px',
  }
}

/**
 * 핸드폰번호 유효성 체크
 * @param {핸드 폰번호} phoneNumber 
 */
export function isPhoneNumberValidation(phoneNumber) {
  var regex = /^(01[016789]{1}|070|02|0[3-9]{1}[0-9]{1})-[0-9]{3,4}-[0-9]{4}$/;
  return regex.test(parsePhoneNumber(phoneNumber.replace(/\-/gi, '')));
}

/**
 * 핸드폰번호 - 붙이기
 * @param {핸드폰 번호} phoneNumber 
 */
export function parsePhoneNumber(phoneNumber) {
  var newPhoneNumber = "";
  if (phoneNumber.length === '10') {
    newPhoneNumber = phoneNumber.substr(0, 3) + "-" + phoneNumber.substr(3, 3) + "-" + phoneNumber.substr(6, 4);
  } else {
    newPhoneNumber = phoneNumber.substr(0, 3) + "-" + phoneNumber.substr(3, 4) + "-" + phoneNumber.substr(7, 4);
  }
  return newPhoneNumber;
}

/**
 * 이메일 주소 유효성 검사
 * @param {이메일 주소} email 
 */
export function isEmailValidation(email) {
  var regex = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/;
  return regex.test(email);
}

/**
 * 초를 00:00 형태로 변경
 * @param {초} seconds 
 */
export function secToMin(seconds) {
  var min = Math.floor(seconds / 60);
  var sec = seconds - (min * 60);
  return leadingZeros(min, 2) + ":" + leadingZeros(sec, 2);
}

/**
 * 자리수에 따라 0 붙이기
 */
export function leadingZeros(n, digits) {
  var zero = '';
  n = n.toString();

  if (n.length < digits) {
    for (var i = 0; i < digits - n.length; i++)
      zero += '0';
  }
  return zero + n;
}

/**
 * 스크롤 작동 중지
 */
var _ycoord = 0;
export function disableScroll() {
  _ycoord = window.scrollY;
  document.body.style.position = 'fixed';
  document.body.style.left = '0px';
  document.body.style.right = '0px';
  document.body.style.top = (_ycoord * -1) + 'px';
}

/**
 * 스크롤 작동
 */
export function enableScroll() {
  document.body.style.position = '';
  document.body.style.left = 'auto';
  document.body.style.right = 'auto';
  document.body.style.top = 'auto';
  window.scrollTo(0, _ycoord);
}

/**
 * 숫자 array 만들기
 * @param {시작값} begin 
 * @param {종료값} end 
 */
export function generateNumberArray(begin, end) {
  let array = [];
  for (let i = begin; i <= end; i++) {
    array.push((i < 10 ? '0' : '') + i);
  }
  return array;
}

/**
 * 배너링크 열기
 */
export function doMoveBannerLink(entity) {
  if(entity.linkUrl) {
    // 클릭한 배너 조회수 증가
    fetch(CONSTS.API_URL + '/banner?id=' + entity.id, null)
    .then(response => response.json())
    .then(json => {
      if(json.resultCode.toLowerCase() === 'success') {
        window.open(entity.linkUrl, "_" + entity.target);
      }
    })
  }
}

/**
 * 배열 중복 제거
 */
export function removeDuplArray(arrays) {
  return arrays.reduce(function(a,b){if(a.indexOf(b)<0)a.push(b);return a;},[]);
}

/**
 * 특수문자 제거
 * @param {} value 
 */
export function removeExp(value) {
  let _regExp = /[\{\}\[\]\/?.,;:|\)*~`!^\-+<>@\#$%&\\\=\(\'\"]/gi;
  return value.replace(_regExp, "");
}

/**
 * 특수문자 체크
 * @param {} value 
 */
export function checkExp(value) {
  let _regExp = /[\{\}\[\]\/?.,;:|\)*~`!^\-+<>@\#$%&\\\=\(\'\"]/gi;
  return _regExp.test(value);
}